module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_honor-deea9c2612a2ac60e67184336419e6dc.png";